import React from "react";
import { Col } from "react-bootstrap";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const ValueOfPackage = () => {
    const { addBreadcrumb } = useBreadcrumbs();
    return (
        <AnimateWrapper>
            <BasicQuestion
                question="Is de waarde van het pakket €6000,- of hoger?"
                answers={
                    <>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                body={"Ja"}
                                onClick={() => {
                                    addBreadcrumb(
                                        {
                                            href: "/contact-information",
                                            text: "Contactgegevens"
                                        },
                                        { EUR1: true }
                                    );
                                }}
                            />
                        </Col>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                body={"Nee"}
                                onClick={() => {
                                    addBreadcrumb(
                                        {
                                            href: "/contact-information",
                                            text: "Contactgegevens"
                                        },
                                        { EUR1: false }
                                    );
                                }}
                            />
                        </Col>
                    </>
                }
            />
        </AnimateWrapper>
    );
};

export default ValueOfPackage;
